import { Controller } from 'stimulus';

const parametersToCapture = [
  'gclid', // Google Ads
  'gclsrc', // Google Ads
  'fbclid', // Facebook Ads
  'mc_cid', // Mailchimp
  'mscklid', // Bing Ads
  'msclkid', // Bing Ads
  'dclid', // DoubleClick
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
];

export const serialize = (obj) => {
  const str = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const p in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  }

  return str.join('&');
};

class AttributionController extends Controller {
  connect() {
    // Throw out old browsers.
    if (typeof Object.fromEntries !== 'function') {
      return;
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    const objToStore = {};

    if (document.referrer && document.referrer.indexOf(window.location.host) < 0) {
      objToStore.referrer = document.referrer;
    }

    Object.keys(params).forEach((paramKey) => {
      if (parametersToCapture.indexOf(paramKey) < 0) {
        return;
      }

      objToStore[paramKey] = params[paramKey];
    });

    if (Object.keys(objToStore).length) {
      this.storeAttribution(objToStore);
    }
  }

  storeAttribution(obj) {
    const attributions = this.attributions();

    attributions.push(obj);

    window.localStorage.setItem('attributions', JSON.stringify(attributions));
  }

  firstAttribution() {
    const attributions = this.attributions();

    return attributions.length
      ? attributions[0]
      : null;
  }

  lastAttribution() {
    const attributions = this.attributions();

    return attributions.length
      ? attributions[attributions.length - 1]
      : null;
  }

  firstAttributionCharacterization() {
    const firstAttribution = this.firstAttribution();

    if (!firstAttribution) {
      return null;
    }

    return AttributionController.characterize(firstAttribution);
  }

  lastAttributionCharacterization() {
    const lastAttribution = this.lastAttribution();

    if (!lastAttribution) {
      return null;
    }

    return AttributionController.characterize(lastAttribution);
  }

  static characterize(attributionObj) {
    if (typeof attributionObj.gclid !== 'undefined' || typeof attributionObj.gclsrc !== 'undefined') {
      return 'google-ads';
    }

    if (typeof attributionObj.referrer !== 'undefined' && attributionObj.referrer.indexOf('google.') >= 0) {
      return 'google';
    }

    if (typeof attributionObj.fbclid !== 'undefined') {
      return 'facebook-ads';
    }

    if (typeof attributionObj.mc_cid !== 'undefined') {
      return 'mailchimp';
    }

    if (typeof attributionObj.mscklid !== 'undefined' || typeof attributionObj.msclkid !== 'undefined') {
      return 'bing-ads';
    }

    if (typeof attributionObj.utm_source !== 'undefined') {
      if (attributionObj.utm_source === 'ActiveCampaign') {
        return 'active-campaign';
      }

      if (attributionObj.utm_source === 'Newsletter') {
        return 'newsletter';
      }
    }

    return 'unknown';
  }

  // eslint-disable-next-line class-methods-use-this
  attributionObjectToQueryString(obj) {
    return serialize(obj);
  }

  // eslint-disable-next-line class-methods-use-this
  attributions() {
    const attributions = window.localStorage.getItem('attributions');

    return typeof attributions === 'string'
      ? JSON.parse(attributions)
      : [];
  }
}

export default AttributionController;
